import { Api } from '../config/api';
import type { ChatHistory } from '../types/ChatWindow';
import type { MessageResponse } from '../types/http';
import { getRequest } from './httpService';

export const getMessagesOfUser = async (id: string): Promise<ChatHistory[]> => {
  const response = await getRequest<MessageResponse>(
    `${Api.REQUESTS.messages}/${id}`,
  );
  return response ? response.chatHistory : [];
};
